module.exports = __webpack_public_path__ + "img/5.f714e093.jpg";